
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17 20C16.71 20 16.44 19.94 16.24 19.85C15.53 19.48 15.03 18.97 14.53 17.47C14.02 15.91 13.06 15.18 12.14 14.47C11.35 13.86 10.53 13.23 9.82 11.94C9.29 10.98 9 9.93001 9 9.00001C9 6.20001 11.2 4.00001 14 4.00001C16.56 4.00001 18.63 5.85001 18.95 8.31001C19.01 8.71001 19.36 9.00001 19.77 9.00001H20.11C20.61 9.00001 21 8.56001 20.94 8.06001C20.49 4.59001 17.61 2.00001 14 2.00001C10.07 2.00001 7 5.07001 7 9.00001C7 10.26 7.38 11.65 8.07 12.9C8.98 14.55 10.05 15.38 10.92 16.05C11.73 16.67 12.31 17.12 12.63 18.1C13.23 19.92 14 20.94 15.36 21.65C15.87 21.88 16.43 22 17 22C18.84 22 20.39 20.76 20.86 19.07C21 18.53 20.61 18 20.05 18H19.7C19.32 18 19.02 18.27 18.89 18.63C18.63 19.42 17.88 20 17 20ZM6.97 1.97001C6.54 1.54001 5.85 1.58001 5.47 2.04001C3.93 3.94001 3 6.36001 3 9.00001C3 11.64 3.93 14.06 5.47 15.95C5.85 16.41 6.54 16.45 6.96 16.03C7.32 15.67 7.35 15.1 7.03 14.71C5.77 13.16 5 11.17 5 9.00001C5 6.83001 5.77 4.84001 7.04 3.30001C7.37 2.90001 7.33 2.33001 6.97 1.97001ZM11.5 9.00001C11.5 10.38 12.62 11.5 14 11.5C15.38 11.5 16.5 10.38 16.5 9.00001C16.5 7.62001 15.38 6.50001 14 6.50001C12.62 6.50001 11.5 7.62001 11.5 9.00001Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-hearing`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconHearing

    ```js
    <b-new-b-icon-hearing />
    ```
</docs>


